/**
 * Feature flags — funzioni nascoste senza cancellare il codice.
 * Riattivare solo quando il servizio è realmente attivo.
 */
// Servizi a pagamento (abbonamento Plus, booking Host, vendita prodotti, offerte parrocchie)
export const SHOW_PAID_SERVICES = false;

// Piazza Social in home (BLOCCO E): si mostra solo quando la Piazza ha
// abbastanza contenuti reali. Oggi la sezione usa cartoline dimostrative
// locali — resta nascosta finché i post reali in Piazza non raggiungono
// almeno HOME_PIAZZA_MIN_POSTS. Riattivare collegando la sezione al feed
// reale /api/wall e impostando il flag a true.
export const HOME_PIAZZA_MIN_POSTS = 10;
export const SHOW_HOME_PIAZZA_FEED = false;

// BLOCCO J — vantaggi extra del Creator Pass (monumenti/musei, degustazione,
// punti drone). Nascosti finché Paolo non li conferma attivi; alla riattivazione
// usare le diciture "nei borghi aderenti" e "nel rispetto delle norme ENAC".
export const SHOW_CREATOR_PASS_EXTRA_BENEFITS = false;

// BLOCCO F — iscrizioni "Cartolina della domenica" dal footer.
// Double opt-in attivo: conferma via mail (72h), consenso registrato,
// disiscrizione con impronta HMAC. Testo Privacy §9 pubblicato.
export const NEWSLETTER_SUBSCRIBE_ENABLED = true;

// "Invia la cartolina a un amico" — sospesa (decisione Paolo):
// l'endpoint attuale salva in chiaro IP mittente ed e-mail destinatario
// e il link "non voglio più cartoline" non blocca davvero l'indirizzo.
// Riattivare solo con la versione Blocco F (HMAC, CAPTCHA, blocco reale).
export const CARTOLINA_FRIEND_ENABLED = false;
